module.exports = __webpack_public_path__ + "static/img/weather.dab7fc9.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/index/weather.png
// module id = R+Gn
// module chunks = 0